import { DotsThreeIcon, MoveIcon, ProductIcon, TagIcon, TrashIcon } from "@/frontend/shared/assets/icons";
import { Logo } from "@/frontend/shared/ui/Logo";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./GridCard.module.scss";
import { TPortfolioCompany } from "../../const/const";
import { Dispatch, RefObject, SetStateAction, useRef, useState } from "react";
import { archiveCompany } from "../../model/services/archiveCompany";
import { convertCompanyStatus } from "@/frontend/shared/lib/convertCompanyStatus/convertCompanyStatus";
import { DropshadowPortalMenu } from "@/frontend/shared/ui/DropshadowPortalMenu/DropshadowPortalMenu";
import { Tag } from "@/frontend/shared/ui/TagV2";

export function GridCard({
  card,
  index,
  setShownModal,
  triggerRefetch,
  addCardTags,
  id,
  scrollContainerRef
}: {
  card: TPortfolioCompany;
  index: number;
  setShownModal: Dispatch<
    SetStateAction<{
      type: string;
      id: number | null;
    }>
  >;
  triggerRefetch: () => void;
  addCardTags: (tag: { name: string; id: number }[]) => void;
  id: number;
  scrollContainerRef: RefObject<HTMLDivElement>;
}) {
  const { tags, notes, staticTags } = card;
  const { logoUrl, name, headline, team } = card.companyData;
  const { name: companyName, headline: companyHeadline } = card;
  const [shownDropshadow, setShownDropshadow] = useState(-1);

  const dotsIconRef = useRef<HTMLDivElement>(null);

  const displayedName = companyName || name;
  const displayedHeadline = companyHeadline || headline;

  function formatFinancialStage(finStage: string) {
    return finStage.replace(/([a-z])([A-Z])/g, "$1 $2");
  }
  return (
    <div className={styles.card}>
      <div className={styles.companyInfo}>
        <div className={styles.titleContainer}>
          <Logo logo={logoUrl || ""} alt="logo" />
          <div className={styles.companyShortInfo}>
            <Typography variant="label-3" color="greyscale900" id="pipelinePage-companyName">
              {displayedName}
            </Typography>
            <Typography
              variant="body-3"
              color="greyscale700"
              className={styles.descriptionField}
              id="pipelinePage-companyHeadline"
            >
              {displayedHeadline}
            </Typography>
          </div>
        </div>

        {(card.companyData.financialStage || tags?.length > 0 || (staticTags?.length ?? 0) > 0) && (
          <div className={styles.tagsContainer} id="pipelinePage-tagsContainer">
            {tags?.map((tag, index) => (
              <Tag children={tag.name} type="custom" key={index} />
            ))}
            {card.companyData.financialStage && (
              <Tag children={convertCompanyStatus(card.companyData.financialStage || "")} type="innovera" />
            )}
            {staticTags?.map((tag) => (
              <Tag children={tag} key={tag} type="innovera" />
            ))}
          </div>
        )}
        <div ref={dotsIconRef}>
          <DotsThreeIcon
            className={styles.dotsThreeIcon}
            onClick={(e) => {
              e.stopPropagation();
              setShownDropshadow(index);
            }}
            id="pipelinePage-companyContextMenuButton"
          />
        </div>
      </div>
      {/* <div className={styles.divider} /> */}
      {/* <div className={styles.bottomContainer}>
        <div className={styles.personsContainer}>
          {team && team.length > 0 ? (
            team.slice(0, 2)?.map((person, index) => {
              return <Avatar name={person} key={index} />;
            })
          ) : (
            <NormalButton leftIcon>Invite Founders</NormalButton>
          )}
          {team && team.length > 2 ? <Tag size="small">+{String(team.length - 2)}</Tag> : null}
        </div>
        <div className={styles.notesContainer}>
          {notes?.slice(0, 2).map((note, index: number) => {
            return (
              <div key={index}>
                <Note note={note.headline} dayOfWeek={formatDate(note.updatedAt)} />
              </div>
            );
          })}
          {notes && notes.length > 2 ? <Tag size="small">+{String(notes.length - 2)}</Tag> : null}
        </div>
      </div> */}
      <DropshadowPortalMenu
        scrollContainerRef={scrollContainerRef}
        isOpen={shownDropshadow === index}
        anchorEl={dotsIconRef.current || undefined}
        onChange={() => setShownDropshadow(index)}
        onClose={() => setShownDropshadow(-1)}
        options={[
          // <div className={styles.dropshadowOption}>
          //   <ShareIcon />
          //   <Typography variant="label-4" color="greyscale800">
          //     Share
          //   </Typography>
          // </div>,
          <div
            className={styles.dropshadowOption}
            onClick={(e) => {
              e.stopPropagation();
              setShownModal({ type: "addTags", id });
              setShownDropshadow(-1);
              addCardTags(card.tags);
            }}
            id="pipelinePage-companyContextMenuOptionTag"
          >
            <TagIcon />
            <Typography variant="label-4" color="greyscale900">
              Tag
            </Typography>
          </div>,
          // <div className={styles.dropshadowOption}>
          //   <NoteAddIcon />
          //   <Typography variant="label-4" color="greyscale900">
          //     Add Note
          //   </Typography>
          // </div>,
          <div
            className={styles.dropshadowOption}
            onClick={(e) => {
              e.stopPropagation();
              setShownModal({ type: "move", id });
              setShownDropshadow(-1);
            }}
            id="pipelinePage-companyContextMenuOptionMove"
          >
            <MoveIcon />
            <Typography variant="label-4" color="greyscale900">
              Move
            </Typography>
          </div>,
          <div
            className={styles.dropshadowOption}
            onClick={(e) => {
              e.stopPropagation();
              setShownModal({ type: "archive", id });
              setShownDropshadow(-1);
            }}
            id="pipelinePage-companyContextMenuOptionArchive"
          >
            <ProductIcon />
            <Typography variant="label-4" color="greyscale900">
              Archive
            </Typography>
          </div>,
          <div
            className={styles.dropshadowOption}
            onClick={(e) => {
              e.stopPropagation();
              setShownModal({ type: "delete", id });
              setShownDropshadow(-1);
            }}
            id="pipelinePage-companyContextMenuOptionRemove"
          >
            <TrashIcon />
            <Typography variant="label-4" color="greyscale900">
              Remove
            </Typography>
          </div>
        ]}
        top="-100px"
        left="120px"
        dividerIndexRate={[1, 3]}
        optionClassName={styles.dropshadowOption}
      />
    </div>
  );
}
